const addedSectorLabels = {
    artificialIntelligence: { tr: 'Yapay Zekâ', en: 'Artificial Intelligence' },
    softwareSaas: { tr: 'Yazılım ve SaaS', en: 'Software and SaaS' },
    fintechFinance: { tr: 'Fintek ve Finans', en: 'Fintech and Finance' },
    healthTechSector: { tr: 'Sağlık Teknolojileri', en: 'Health Technologies' },
    biotechLifeSciences: { tr: 'Biyoteknoloji ve Yaşam Bilimleri', en: 'Biotechnology and Life Sciences' },
    edtechSector: { tr: 'Eğitim Teknolojileri (EdTech)', en: 'Education Technology (EdTech)' },
    hrTech: { tr: 'İnsan Kaynakları Teknolojileri (HRTech)', en: 'Human Resources Technology (HRTech)' },
    martechSector: { tr: 'Pazarlama Teknolojileri (MarTech)', en: 'Marketing Technology (MarTech)' },
    ecommerceMarketplace: { tr: 'E-Ticaret ve Pazaryeri', en: 'E-commerce and Marketplace' },
    retailTech: { tr: 'Perakende Teknolojileri', en: 'Retail Technology' },
    mediaEntertainment: { tr: 'Medya ve Eğlence', en: 'Media and Entertainment' },
    cybersecurity: { tr: 'Siber Güvenlik', en: 'Cybersecurity' },
    agrifoodTech: { tr: 'Tarım ve Gıda Teknolojileri', en: 'Agriculture and Food Technology' },
    climateSustainability: { tr: 'İklim ve Sürdürülebilirlik', en: 'Climate and Sustainability' },
    energy: { tr: 'Enerji', en: 'Energy' },
    mobilityTransport: { tr: 'Mobilite ve Ulaşım', en: 'Mobility and Transportation' },
    logisticsSupplyChain: { tr: 'Lojistik ve Tedarik Zinciri', en: 'Logistics and Supply Chain' },
    automotive: { tr: 'Otomotiv', en: 'Automotive' },
    roboticsAutomation: { tr: 'Robotik ve Otomasyon', en: 'Robotics and Automation' },
    defenseAerospace: { tr: 'Savunma ve Havacılık', en: 'Defense and Aerospace' },
    spaceTech: { tr: 'Uzay Teknolojileri', en: 'Space Technology' },
    realEstateConstructionTech: { tr: 'Gayrimenkul ve İnşaat Teknolojileri', en: 'Real Estate and Construction Technology' },
    manufacturingIndustryTech: { tr: 'Üretim ve Sanayi Teknolojileri', en: 'Manufacturing and Industrial Technology' },
    deepTechAdvancedMaterials: { tr: 'Derin Teknoloji ve İleri Malzemeler', en: 'Deep Tech and Advanced Materials' }
};

export const getSectorOptions = (t, language) => {
    const isEnglish = language?.startsWith('en');
    const existingSectors = [
        { key: 'fintech', value: 'FinTech' },
        { key: 'saas', value: 'SaaS' },
        { key: 'ecommerce', value: 'E-commerce' },
        { key: 'healthtech', value: t('sharedEntrepreneurInfo.sectors.healthtech') },
        { key: 'edtech', value: t('sharedEntrepreneurInfo.sectors.edtech') },
        { key: 'gaming', value: t('sharedEntrepreneurInfo.sectors.gaming') },
        { key: 'ai', value: t('sharedEntrepreneurInfo.sectors.ai') },
        { key: 'martech', value: t('sharedEntrepreneurInfo.sectors.martech') },
        { key: 'blockchain', value: 'Blockchain' },
        { key: 'other', value: t('sharedEntrepreneurInfo.sectors.other') }
    ];

    const additionalSectors = Object.entries(addedSectorLabels).map(([key, labels]) => ({
        key,
        value: isEnglish ? labels.en : labels.tr
    }));

    return [...existingSectors, ...additionalSectors];
};

export const getCompanyStages = (language) => {
    const isEnglish = language?.startsWith('en');
    const labels = isEnglish
        ? ['Idea Stage', 'Early Stage / Startup', 'Operating', 'Growth Stage', 'Scaling Stage', 'SME', 'Corporate / Mature Company', 'Other']
        : ['Fikir Aşaması', 'Erken Aşama / Startup', 'Faaliyette', 'Büyüme Aşaması', 'Ölçekleme Aşaması', 'KOBİ', 'Kurumsal / Olgun Şirket', 'Diğer'];
    const keys = ['idea', 'earlyStartup', 'operating', 'growth', 'scaling', 'sme', 'corporateMature', 'other'];

    return keys.map((key, index) => ({ key, value: key, label: labels[index] }));
};

export const isDcfOnlyCompanyStage = (stage) => {
    const normalizedStage = String(stage || '').trim().toLowerCase().replace(/[\s_/-]+/g, '');
    return ['sme', 'kobi', 'corporatemature', 'corporatematurecompany', 'kurumsalolgunşirket'].includes(normalizedStage);
};

export const getCompanyStageLabel = (stage, language) => {
    const stages = getCompanyStages(language);
    const selectedStage = stages.find(option => option.key === stage);
    if (selectedStage) return selectedStage.label;

    const legacyLabels = {
        'Pre-Seed': language?.startsWith('en') ? 'Pre-Seed' : 'Tohum öncesi',
        Seed: language?.startsWith('en') ? 'Seed' : 'Tohum',
        'Series A': language?.startsWith('en') ? 'Series A' : 'Seri A',
        'Series B, C, D...': language?.startsWith('en') ? 'Series B, C, D...' : 'Seri B ve sonrası',
        preseed: language?.startsWith('en') ? 'Pre-Seed' : 'Tohum öncesi',
        seed: language?.startsWith('en') ? 'Seed' : 'Tohum',
        seriesA: language?.startsWith('en') ? 'Series A' : 'Seri A',
        seriesB: language?.startsWith('en') ? 'Series B, C, D...' : 'Seri B ve sonrası'
    };

    return legacyLabels[stage] || stage || '-';
};

